import { render, staticRenderFns } from "./chainSupplier.vue?vue&type=template&id=80251404&scoped=true"
import script from "./chainSupplier.vue?vue&type=script&lang=js"
export * from "./chainSupplier.vue?vue&type=script&lang=js"
import style0 from "./chainSupplier.vue?vue&type=style&index=0&id=80251404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80251404",
  null
  
)

export default component.exports